import * as React from "react";
import { forwardRef } from "react";
const SvgHorizontalDivider = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 649 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M648.16 3.99683L324.16 16.9968L0.160147 3.9968", stroke: "#182231", strokeWidth: 8 }));
const ForwardRef = forwardRef(SvgHorizontalDivider);
export { ForwardRef as ReactComponent };
